import type * as yup from 'yup';

import { campSchema } from '@/features/Sparten/campv2/schema/schema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const inputSchema = campSchema;

export type InputStore = yup.Asserts<typeof inputSchema>;

/**
 * State-Default lazy über `campSchema.getDefault()` — bewusst das Live-Binding `campSchema`,
 * NICHT die Variable `inputSchema`.
 *
 * Grund: zirkulärer Import (subSchema → useInputStore → schema → subSchema). `inputSchema`
 * kann ein eingefrorener Snapshot einer noch unvollständigen `campSchema` sein (z.B.
 * `fahrzeug` undefined) → „Cannot use 'in' operator … in undefined". Das Live-Binding
 * `campSchema` ist zur Laufzeit dagegen vollständig aufgelöst.
 */
export const useCampv2InputStore = genericStoreFactory(
  () => campSchema.getDefault(),
  'Campv2InputStore',
);
